'use es6';

import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import * as Sync from 'ecosystem-marketplace-core/constants/dataSyncs/Sync';
import * as SuperCategory from 'ecosystem-marketplace-core/constants/groupTags/SuperCategory';
import * as HubSpotFeature from 'marketplace-ui-apps-core/common/constants/groupTags/HubSpotFeature';
import { BY_CATEGORY as FEATURES_BY_CATEGORY } from 'ecosystem-marketplace-core/constants/groupTags/categoryFeatures';
import categoryPropType from 'ecosystem-marketplace-core/constants/propTypes/category';
import createObjectValuesPropType from 'ecosystem-marketplace-core/constants/propTypes/createObjectValuesPropType';
import planTypePropType from 'ecosystem-marketplace-core/constants/propTypes/planType';
import Screenshot from 'marketplace-ui-common/records/Screenshot';
import AppInstallability from 'ecosystem-marketplace-core/records/AppInstallability';
import StorefrontFilters from '../records/StorefrontFilters';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import * as ConnectionType from './ConnectionType';
import Review from 'marketplace-ui-reviews/records/Review';
import ReviewsStats from 'marketplace-ui-reviews/records/ReviewStats';
export const category = categoryPropType;
export const superCategory = createObjectValuesPropType(SuperCategory);
export const dataSyncDirection = createObjectValuesPropType(Sync);
export const categoryFeature = PropTypes.oneOf(Object.values(FEATURES_BY_CATEGORY).reduce((acc, current) => acc.concat(Object.values(current)), []));
export const hubspotFeature = createObjectValuesPropType(HubSpotFeature);
export const pricingPlanType = planTypePropType;
export const storefrontFilters = PropTypes.instanceOf(StorefrontFilters);
export const requestState = createObjectValuesPropType(RequestState);
export const connectionType = createObjectValuesPropType(ConnectionType);
export const reviews = ImmutablePropTypes.listOf(PropTypes.instanceOf(Review));
export const reviewStats = PropTypes.instanceOf(ReviewsStats);
export const installability = PropTypes.instanceOf(AppInstallability);
export const screenshot = PropTypes.instanceOf(Screenshot);

// intended to mimic the shape of ListingWorkingCore from marketplace-ui-client-types until we refactor the consuming components to TS
export const ListingWorkingCore = PropTypes.shape({
  headline: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  hubSpotFeatures: PropTypes.arrayOf(PropTypes.string).isRequired
});

// intended to mimic the shape of ScopeGroup from marketplace-ui-client-types until we refactor the consuming components to TS
export const ScopeGroup = PropTypes.shape({
  id: PropTypes.number.isRequired,
  longDescription: PropTypes.string,
  name: PropTypes.string.isRequired,
  pictoIcon: PropTypes.string,
  shortDescription: PropTypes.string.isRequired,
  whitelisted: PropTypes.bool,
  version: PropTypes.oneOf(['GRANULAR', 'LEGACY']).isRequired,
  visibility: PropTypes.oneOf(['HIDDEN', 'VISIBLE']).isRequired
});

// intended to mimic the shape of ListingPricingCore from marketplace-ui-client-types until we refactor the consuming components to TS
export const ListingPricingCore = PropTypes.shape({
  amount: PropTypes.number,
  commitmentAmount: PropTypes.number,
  contactUsDetails: PropTypes.string,
  contactUsUrl: PropTypes.string,
  extraCharges: PropTypes.string,
  features: PropTypes.string,
  freeTrialDays: PropTypes.number,
  meterUnit: PropTypes.string,
  name: PropTypes.string,
  tagline: PropTypes.string,
  updatedAt: PropTypes.number,
  contactUsPlanType: PropTypes.oneOf(['MONTHLY', 'ONE_TIME', 'YEARLY']),
  planType: PropTypes.oneOf(['CONTACT_US', 'FREE', 'METERED', 'MONTHLY', 'ONE_TIME', 'YEARLY'])
}).isRequired;